<div class="mat-elevation-z8">
  <div fxLayoutGap="15px">
    <table
      id="gridContainer"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortData($event)"
      multiTemplateDataRows>
      <ng-container matColumnDef="jpegPhoto">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TABLE.SERVICES.HEADER.IMG' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container
            [ngTemplateOutlet]="serviceImgFragment"
            [ngTemplateOutletContext]="{ url: element.jpegPhoto }" />
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="title"
          class="sortable">
          {{ 'TABLE.SERVICES.HEADER.NAME' | translate }}
          <mat-icon
            [style.color]="sortedValue !== 'title' ? '#757575' : 'transparent'"
            class="sort-icon"
            >sort</mat-icon
          >
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.title }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TABLE.SERVICES.HEADER.DESCRIPTION' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>

      <ng-container matColumnDef="help">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TABLE.SERVICES.HEADER.HELP' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          @if (element.help !== '') {
            <button
              mat-button
              color="accent"
              (click)="openDocumentation(element)">
              <mat-icon mat-list-icon>help_outline</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="accessurl">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TABLE.SERVICES.HEADER.ACCESS' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-button
            color="accent"
            class="access-btn"
            (click)="openService(element)"
            [ngClass]="{ maintenance: element.maintenance }"
            [ngStyle]="{ opacity: element.maintenance ? 0.2 : 1 }"
            [disabled]="element.maintenance">
            {{ 'GENERAL.ACCESS' | translate }}
          </button>
          @if (element.maintenance) {
            <mat-icon
              class="check-icon"
              color="error"
              [matTooltip]="'GENERAL.SERVICEMAINTENACE' | translate"
              matTooltipPosition="above"
              >error_outline</mat-icon
            >
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="toggleRow(element)">
            <mat-icon>more_horiz</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length">
          @if (expandedElement === element && windowWidth <= 800) {
            <div class="expanded-detail">
              @if (windowWidth <= 400) {
                <p>
                  <strong
                    >{{ 'TABLE.SERVICES.HEADER.IMG' | translate }}:</strong
                  >
                  <ng-container
                    [ngTemplateOutlet]="serviceImgFragment"
                    [ngTemplateOutletContext]="{ url: element.jpegPhoto }" />
                </p>
              }
              <p>
                <strong
                  >{{
                    'TABLE.SERVICES.HEADER.DESCRIPTION' | translate
                  }}:</strong
                >
                {{ element.description }}
              </p>
              @if (element.help !== '' && windowWidth <= 550) {
                <p>
                  <strong
                    >{{ 'TABLE.SERVICES.HEADER.HELP' | translate }}:</strong
                  >
                  <button
                    mat-button
                    color="accent"
                    (click)="openDocumentation(element)">
                    <mat-icon mat-list-icon>help_outline</mat-icon>
                  </button>
                </p>
              }
            </div>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let index = dataIndex; columns: displayedColumns"
        class="element-row"
        [ngClass]="{ alternate: index % 2 === 0 }"></tr>
      <tr
        mat-row
        *matRowDef="let row; let index = dataIndex; columns: ['expandedDetail']"
        class="detail-row"
        [ngClass]="{ alternate: index % 2 === 0 }"></tr>
    </table>
  </div>
  <mat-paginator [hidePageSize]="true" [pageSize]="10" showFirstLastButtons>
  </mat-paginator>
</div>

<ng-template #serviceImgFragment let-imgUrl="url">
  @if (imgUrl !== '') {
    <img
      [src]="
        imgUrl.includes('/assets/images/maintenance/services/')
          ? imgUrl
          : 'data:image/png;base64,' + imgUrl
      "
      class="serviceImageTable"
      alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
  } @else {
    <img
      src="../../../assets/images/cards/noimage.png"
      class="serviceImageTable"
      alt="{{ 'GENERAL.EMPTY_IMAGE' | translate }}" />
  }
</ng-template>
